import React from 'react'
import Prescription from '../../../Components/UserComponents/Prescription/Prescription'
import Header from '../../../Components/UserComponents/Header/Header';
import Footer from '../../../Components/UserComponents/Footer/Footer';


const PrescriptionPage = () => {
    return (
        <div>
            <Header />
            <Prescription />
            <Footer />
        </div>
    )
}

export default PrescriptionPage